import { Controller, useFormContext } from 'react-hook-form';

import { Switch } from 'components/DesignSystem/Switch';
import { FormProps } from 'components/widgets/CustomerProfile/CustomerProfile';

export const ConfettiOn = () => {
    const methods = useFormContext<FormProps>();
    return (
        <div>
            <Controller
                render={({ field }) => (
                    <Switch
                        checked={field.value}
                        onChange={field.onChange}
                        label={'Confetti on'}
                        labelPlacement={'start'}
                    />
                )}
                name={`confettiOn`}
                control={methods.control}
            />
        </div>
    );
};
